// extracted by mini-css-extract-plugin
module.exports = {"entity_actions":"entity-actions_entity_actions___FIaQ","menu_button":"entity-actions_menu_button__8wzDR"};